/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class AdminOpsInternalService {

  constructor(private http: HttpClient) { }

  reprocessData() {
    return this.http
      .post(
        `/api/v1/admin/internal/goldenset/refresh`,
        {}
    );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/admin/admin-ops-internal.service.ts